export default [
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "studyInfo",
    name: "Study Info",
    component: () => import("../form/builder/StudyInfo.vue"),
    meta: { title: "KHRDC-Builder", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "criteria",
    name: "Criteria",
    component: () => import("../form/builder/Criteria.vue"),
    meta: { title: "KHRDC-Builder", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "regimen",
    name: "Regimen",
    component: () => import("../form/builder/Regimen.vue"),
    meta: { title: "KHRDC-Builder", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "visitTab",
    name: "Visit Tab",
    component: () => import("../form/builder/VisitTab.vue"),
    meta: { title: "KHRDC-Builder", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "visitTest",
    name: "Visit Test",
    component: () => import("../form/builder/VisitTest.vue"),
    meta: { title: "KHRDC-Builder", requiresAuth: true, isAdmin: true },
  },
  {
    // path 값 처음에 /를 붙이지 않으면 부모 route의 path 뒤에 자동으로 붙음
    // ex)  path: 'institution' -> admin/institution
    path: "adverseEvent",
    name: "Adverse Event",
    component: () => import("../form/builder/AdverseEvent.vue"),
    meta: { title: "KHRDC-Builder", requiresAuth: true, isAdmin: true },
  },
];
